<div class="app-wrapper">
  <p-toast key="notification" position="top-right"></p-toast>
  <router-outlet></router-outlet>
</div>

<p-toast key="delivery-proof-success"></p-toast>


